import React, {useState} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";

import {useTranslation} from 'react-i18next';
import {LatLng} from 'leaflet';
import PopoverActionAddPointMutateSingleVoyage from "./popover/PopoverActionAddPointMutateSingleVoyage";
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";
import {sx} from "@containers/singleVoyage/mutateVoyage/points/map/addPointOnTheMap/popover/sx";

import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {classNames} from "@helpers/classNames";

import LeafletMarker from "@ui/leafletCustom/leafletMarker/LeafletMarker";
import {
    buildIconAddPointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/map/addPointOnTheMap/helpers/buildIconAddPointMutateSingleVoyage";
import {
    useAddHandlersAddPointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/map/addPointOnTheMap/hooks/useAddHandlersAddPointMutateSingleVoyage";
import {
    useAddPointActionMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useAddPointActionsMutateSingleVoyage";

const icon = buildIconAddPointMutateSingleVoyage()

const AddPointOnTheMapMutateSingleVoyage = () => {

    const {t} = useTranslation()
    const {theme} = useThemeContext()

    const [openPopoverAction, setOpenPopoverAction] = useState<boolean>(false)
    const [positionPopoverAction, setPositionPopoverAction] = useState<{ top: number, left: number }>()
    const [latLng, setLatLng] = useState<{ lat: number, lng: number } | null>()

    const {
        showAddPointIcon,
        setShowAddPointIcon,
        setActivePointHelperIndicator,
    } = useRootContextMutateSingleVoyage()

    const {
        onAddPoint,
        isLoading,
    } = useAddPointActionMutateSingleVoyage()

    const {markerEventHandlers} = useAddHandlersAddPointMutateSingleVoyage({
        setLatLng,
        setOpenPopoverAction,
        setPositionPopoverAction,
        setActivePointHelperIndicator,
    })

    const onAdd = async () => {
        await onAddPoint(latLng)
        setLatLng(null)
        setOpenPopoverAction(false)
        setActivePointHelperIndicator(false)
        setShowAddPointIcon(false)
    }

    const onClosePopover = () => {
        setOpenPopoverAction(false)
        setActivePointHelperIndicator(false)
    }

    return (
        <>

            {openPopoverAction &&
                <PopoverActionAddPointMutateSingleVoyage
                    anchorPosition={positionPopoverAction}
                    open={openPopoverAction}
                    onClose={onClosePopover}
                >
                    <PrimaryButtonSingleVoyage
                        onClick={onAdd}
                        sx={sx.btn}
                        fullWidth
                        className={classNames(theme === 'dark' && 'darkTheme')}
                        disabled={isLoading}
                    >
                        {t('base.addPoint')}
                    </PrimaryButtonSingleVoyage>
                </PopoverActionAddPointMutateSingleVoyage>}

            {showAddPointIcon && latLng?.lng && <LeafletMarker
                eventHandlers={markerEventHandlers}
                draggable
                position={new LatLng(latLng.lat ?? 0, latLng.lng ?? 0)}
                icon={icon}
            />}
        </>
    );
};

export default AddPointOnTheMapMutateSingleVoyage;
